export const CSRBuddyTypes = {
    AutoshipCanceled: 'AUTOSHIP_CANCELLED',
    CreateAction: 'CREATE',
    EnterpriseStyleSheet: 'https://static.chewy.com/lib/dft/1.10.0/css/themes/theme-enterprise.css',
  } as const;